import { memo } from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { getReadablePlatform } from 'root/src/shared/platforms/helpers/getReadablePlatform';
import { buildAssetUrl, assetSize } from 'root/src/client/v2/common/helpers/assetUrl';
import { Img } from 'root/src/client/v2/common/components/ui/image';
const RELATED_PROFILES_TOOLTIP = 'This username exists on multiple platforms as separate, unlinked accounts. '
    + 'Each one has its own profile, stats and history on Dare Drop. If you own both, connect them in Connected Channels.';
const followersFormatter = new Intl.NumberFormat('en-US');
export const CreatorRelatedProfiles = memo(({ profiles }) => {
    if (!(profiles === null || profiles === void 0 ? void 0 : profiles.length)) {
        return null;
    }
    return (<section className="mt-6">
			<div className="mb-3 flex items-center gap-1.5">
				<span className="text-xs font-bold uppercase tracking-wider text-muted-foreground">Related Profiles</span>
				<InfoOutlinedIcon sx={{ fontSize: 14 }} className="cursor-help text-muted-foreground" titleAccess={RELATED_PROFILES_TOOLTIP}/>
			</div>
			<div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap">
				{profiles.map((profile) => {
            var _a, _b, _c, _d;
            const platformLabel = (_a = getReadablePlatform(profile.platform)) !== null && _a !== void 0 ? _a : profile.platform;
            return (<a key={`${profile.platform}-${profile.platformId}`} href={profile.daredropUrl} className="glass flex items-center gap-3 rounded-2xl border border-solid border-white/[0.08] p-3 transition-colors hover:border-neon-pink/30">
							<Img src={buildAssetUrl(profile.image, { w: assetSize('thumbnail'), q: 80, fmt: 'webp' })} alt={(_c = (_b = profile.displayName) !== null && _b !== void 0 ? _b : platformLabel) !== null && _c !== void 0 ? _c : 'Related profile'} className="h-10 w-10 rounded-full object-cover"/>
							<div className="min-w-0">
								<span className="block truncate text-sm font-semibold text-foreground">{profile.displayName}</span>
								<span className="text-xs text-muted-foreground">
									{platformLabel} · {followersFormatter.format((_d = profile.followerCount) !== null && _d !== void 0 ? _d : 0)} followers
								</span>
							</div>
						</a>);
        })}
			</div>
		</section>);
});
